class LqdTabsHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.initTabs();

  }

  getDefaultSettings() {
    return {
      selectors: {
        tabElement: '.lqd-tabs',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $tabElement: this.$element.find(selectors.tabElement),
    }
  }

  initTabs() {

    this.elements.$tabElement.liquidTab();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleTabDestroy();

  }

  handleTabDestroy() {

    if ( ! this.elements.$tabElement.length ) return;

    const tabData = this.elements.$tabElement.data('plugin_liquidTab');

    if ( tabData ) {
      tabData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdTabsHandler, { $element } );
};